import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FullTextButton from '../FullTextButton';
import SaveToLibrary from '../SaveToLibrary';
import PdfIcon from '../PdfIcon';
import BounceLoader from '../BounceLoader';
import { getEntitlement } from '../../actions/entitlements';
import { showPdf } from '../../actions/document';

class PublicationActions extends Component {
  componentDidMount() {
    const {
      doc,
      checkedEntitlement,
      psiEnabled,
    } = this.props;

    if (psiEnabled && doc.hasPdf && !checkedEntitlement) {
      this.props.getEntitlement(doc.id);
    }
  }

  render() {
    const {
      doc,
      track,
      currentPage,
      position,
      isEntitled,
      isAuthenticated,
      checkedEntitlement,
      psiEnabled,
    } = this.props;

    if (!psiEnabled) {
      return (
        <div className="button-group">
          <SaveToLibrary
            doc={doc}
            buttonStyle="basic"
            track={track}
            currentPage={currentPage}
            position={position}
            tertiary
          />
          <FullTextButton
            doc={doc}
            track={track}
            currentPage={currentPage}
            position={position}
          >
            Get full text at journal
          </FullTextButton>
        </div>
      );
    }

    const { doi } = doc.identifiers || {};

    const showSaveToLibrary =
      !doc.hasPdf ||
      (doc.hasPdf && checkedEntitlement) ||
      (doc.hasPdf && isAuthenticated);

    const showGetFullText =
      !doc.hasPdf || (checkedEntitlement && !isEntitled);

    const showViewPdf =
      doc.hasPdf && isAuthenticated && isEntitled;

    return (
      <div className="button-group">
        {showSaveToLibrary && (
          <SaveToLibrary
            doc={doc}
            buttonStyle="basic"
            track={track}
            currentPage={currentPage}
            position={position}
            isEntitled={isEntitled}
            tertiary
          />
        )}
        {(showViewPdf && (
          <a
            className="button-basic with-icon-after view-pdf"
            href={`/research-papers/api/pdf/${doc.id}/${doi ? `?doi=${doi}` : ''}`}
            target="_blank"
            data-name="view-pdf"
            onClick={() => this.props.showPdf(doc.id)}
          >
            <PdfIcon />
            <span>View PDF</span>
          </a>
        ))}
        {showGetFullText && (
          <FullTextButton
            doc={doc}
            track={track}
            currentPage={currentPage}
            position={position}
          >
            Get full text at journal
          </FullTextButton>
        )}
        {isAuthenticated && !showViewPdf && !showGetFullText && (
          <BounceLoader />
        )}
      </div>
    );
  }
}

PublicationActions.propTypes = {
  doc: PropTypes.object.isRequired,
  track: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
};

const mapStateToProps = (state, props) => ({
  isAuthenticated: state.session.isAuthenticated,
  isEntitled: state.entitlements[props.doc.id],
  checkedEntitlement: typeof state.entitlements[props.doc.id] !== 'undefined',
  psiEnabled: state.config.features.psiEnabled,
});

const mapDispatchToProps = {
  getEntitlement,
  showPdf,
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicationActions);



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResults/PublicationActions.js